import { useToast } from "vue-toastification/composition";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "@/router";
import axios from "@axios";
import {
  reactive,
  toRefs,
  onMounted,
  ref,
} from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { v4 as uuidv4 } from "uuid";
import { fieldStructure } from "@/components/riskTemplateBuilder/config";

export default function useTemplateBuilderConfig() {

  const state = reactive({
    items: [
      {
        name: "",
        type: "facility",
        logic: [],
        errors: {},
        item_id: "facility",
        options: { required: false, fieldTypeCfg: { data: [] } },
        hasErrors: false,
        isDefault: true,
      },
    ],
    isValid: false,
    templateId: null,
    isUpdating: false,
  });

  const templateName = ref("");
     const idTenant = ref(null);
  const toast = useToast();
  const { refFormObserver, getValidationState } = formValidation();
  const { t } = useI18nUtils();
  const trans = {
    'messages.edit_save.successfully_created': t('messages.edit_save.successfully_created'),
    'messages.edit_save.updated_successfully': t('messages.edit_save.updated_successfully'),
  };

  const addItem = () => {
    const item = JSON.parse(JSON.stringify(fieldStructure));
    item.item_id = uuidv4();
    state.items.push(item);
  };

  const save = async (extra = {}) => {
    const validation = await refFormObserver.value.validate();
    if (validation) {
      storeTemplate(
        templateName.value,
        state.items,
        extra //In this case just id_tenant
      );
    }
  };

  const storeTemplate = (name, data, extra = {}) => {
    const payload = {
      name,
      data,
      ...extra,
    };

    if (!state.isUpdating) {
      axios.post("v1/risk_templates", payload).then(({ data }) => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans['messages.edit_save.successfully_created'],
            icon: "CheckIcon",
            variant: "success",
          },
        });

        state.isUpdating = true;
        state.templateId = data.id;

        router.push({ path: `/risk/templates/builder/${state.templateId}` });
      });
    } else {
      axios.put(`v1/risk_templates/${state.templateId}`, payload).then(({ data }) => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans['messages.edit_save.updated_successfully'],
            icon: "CheckIcon",
            variant: "success",
          },
        });

        state.templateId = data.id;
        router.push({ path: `/risk/templates/builder/${state.templateId}` });
      });
    }
  };

  onMounted(async () => {
    if (router.currentRoute.params.id_template) {
      state.isUpdating = true;
      state.templateId = router.currentRoute.params.id_template;

      const { data } = await axios.get(`v1/risk_templates/${state.templateId}`);
      const response = data;


      templateName.value = response.name;
      idTenant.value = response.id_tenant ?? response.tenant?.id ?? null;
      if (response.data) {
        state.items = response.data;
      }
    }
  });

  return {
    addItem,
    save,
    ...toRefs(state),
    templateName,
    idTenant,
    refFormObserver,
    getValidationState,
    required,
  };
}
